// extracted by mini-css-extract-plugin
export default {"avatar":"EditProfilePage_avatar__qw1Zt"};